import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container']
  static values = { interval: { type: Number, default: 4000 } }

  connect() {
    this.cloneCards()
    this.startAutoScroll()
  }

  disconnect() {
    this.stopAutoScroll()
  }

  cloneCards() {
    const el = this.containerTarget
    const cards = el.querySelectorAll('[data-sync-card]')
    cards.forEach(card => {
      const clone = card.cloneNode(true)
      clone.setAttribute('data-clone', 'true')
      el.appendChild(clone)
    })
    this.originalWidth = Array.from(cards).reduce((sum, c) => sum + c.offsetWidth + 16, 0)
  }

  startAutoScroll() {
    this.autoScrollTimer = setInterval(() => this.advance(), this.intervalValue)
  }

  stopAutoScroll() {
    if (this.autoScrollTimer) {
      clearInterval(this.autoScrollTimer)
      this.autoScrollTimer = null
    }
  }

  resetAutoScroll() {
    this.stopAutoScroll()
    this.startAutoScroll()
  }

  advance() {
    const el = this.containerTarget

    if (el.scrollLeft >= this.originalWidth) {
      el.scrollLeft = 0
    }

    const card = el.querySelector('[data-sync-card]')
    if (!card) return
    el.scrollBy({ left: card.offsetWidth + 16, behavior: 'smooth' })
  }

  scrollLeft() {
    const card = this.containerTarget.querySelector('[data-sync-card]')
    if (!card) return
    this.containerTarget.scrollBy({ left: -(card.offsetWidth + 16), behavior: 'smooth' })
    this.resetAutoScroll()
  }

  scrollRight() {
    const card = this.containerTarget.querySelector('[data-sync-card]')
    if (!card) return
    this.containerTarget.scrollBy({ left: card.offsetWidth + 16, behavior: 'smooth' })
    this.resetAutoScroll()
  }

  pause() {
    this.stopAutoScroll()
  }

  resume() {
    this.startAutoScroll()
  }
}
